// Ameen basket builders: cart-drawer add-ons row + per-unit pricing on product pages.
// Standalone on purpose: it reads the DOM that ameen-cart.js and ameen-product.liquid render,
// so it can be removed by deleting one <script> tag without touching either of those files.
(function(){
  var esc = function(s){ return (s+'').replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); };

  var css = '\
  .ab-addons{padding:16px 0 8px;display:none}\
  .ab-addons--dock{flex:0 0 auto;padding:12px 26px 10px;border-top:1px solid var(--line,rgba(201,162,74,.16))}\
  .ab-addons__h{font-size:11px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--gold-soft,#e3c987);margin:0 0 9px}\
  .ab-addons__row{display:flex;gap:10px;overflow-x:auto;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scroll-snap-type:x proximity;scrollbar-width:none;padding-bottom:2px}\
  .ab-addons__row::-webkit-scrollbar{display:none}\
  @media (hover:hover) and (pointer:fine){.ab-addons__row{scrollbar-width:thin;scrollbar-color:rgba(201,162,74,.45) transparent;padding-bottom:8px}.ab-addons__row::-webkit-scrollbar{display:block;height:6px}.ab-addons__row::-webkit-scrollbar-thumb{background:rgba(201,162,74,.45);border-radius:6px}}\
  .ab-addon{flex:0 0 auto;width:208px;scroll-snap-align:start;display:grid;grid-template-columns:40px 1fr auto;gap:9px;align-items:center;padding:7px 9px;border:1px solid var(--line,rgba(201,162,74,.16));border-radius:12px;background:rgba(255,255,255,.015);margin:0}\
  @media (max-width:380px){.ab-addon{width:188px}}\
  .ab-addon img{width:40px;height:40px;border-radius:8px;object-fit:cover;background:#1a160f}\
  .ab-addon__t{font-size:12.5px;line-height:1.25;color:var(--cream,#f3ead8);display:block;text-decoration:none;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}\
  .ab-addon__s{font-size:11.5px;color:rgba(243,234,216,.62);margin-top:2px}\
  .ab-addon__s b{color:var(--cream,#f3ead8);font-weight:700}\
  .ab-addon__tag{display:block;font-size:10.5px;font-weight:700;letter-spacing:.03em;color:var(--gold-soft,#e3c987);margin-top:2px}\
  .ab-addon button{width:32px;height:32px;border-radius:50%;border:1px solid var(--gold,#c9a24b);background:none;color:var(--gold-soft,#e3c987);font-size:18px;line-height:1;cursor:pointer;transition:.3s}\
  .ab-addon button:hover{background:var(--gold,#c9a24b);color:#1a1306}\
  .ab-addon button:disabled{opacity:.5;cursor:default}\
  #optRow .opt small:not(.ab-unit){display:block;font-size:16px;font-weight:700;line-height:1.2;margin-top:3px;opacity:1;color:rgba(243,234,216,.86)}\
  #optRow .opt.active small:not(.ab-unit){color:var(--cream,#f3ead8)}\
  #optRow .opt small.ab-unit{display:block;font-size:11px;font-weight:500;line-height:1.25;opacity:1;color:rgba(243,234,216,.62);margin-top:3px;letter-spacing:.01em;white-space:nowrap}\
  #optRow .opt.active small.ab-unit{color:rgba(243,234,216,.74)}\
  #optRow .opt:disabled small{opacity:.6}\
  .opt .ab-best{display:block;font-style:normal;font-size:9.5px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--gold-soft,#e3c987);margin-top:3px}\
  .cart-dr__foot [data-ameen-ship-note] + .cart-dr__note{display:none}\
  .ab-unitline{display:block;font-size:12.5px;color:rgba(243,234,216,.66);margin:-6px 0 14px;letter-spacing:.01em}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);

  /* ---------- 1. Cart drawer add-ons ---------- */
  var ADDONS = window.AMEEN_ADDONS || [];
  function curFmt(cents, cur){
    try{ return new Intl.NumberFormat('en',{style:'currency',currency:cur||'CAD',currencyDisplay:'narrowSymbol'}).format(cents/100); }
    catch(e){ return '$'+(cents/100).toFixed(2); }
  }
  function threshold(cur){
    var cfg = window.AMEEN_SHIPPING || {};
    var cad = Number(cfg.cadCents)||0;
    if(!cad) return 0;
    if(cur==='CAD') return cad;
    var fx = window.Shopify && window.Shopify.currency;
    var rate = (fx && fx.active===cur) ? Number(fx.rate) : NaN;
    return (isFinite(rate) && rate>0) ? Math.ceil(cad*rate) : 0;
  }
  function pickAddons(cart){
    var inCart = {};
    (cart.items||[]).forEach(function(i){ inCart[i.product_id]=1; });
    var pool = ADDONS.filter(function(a){ return !inCart[a.pid]; });
    var thr = threshold(cart.currency||'CAD');
    var total = Number(cart.total_price)||0;
    var gap = thr>0 && total<thr ? thr-total : 0;
    var closers = [], others = [];
    if(gap>0){
      pool.forEach(function(a){ (a.c>=gap ? closers : others).push(a); });
      closers.sort(function(a,b){ return a.c-b.c; });   // the smallest item that still gets them over the line comes first
      others.sort(function(a,b){ return b.c-a.c; });    // otherwise lead with whatever gets them closest
    } else {
      others = pool.slice(); // keep the merchandiser's collection order
    }
    var list = closers.concat(others).slice(0,6);
    return {list:list, gap:gap, closes:closers.length ? closers : []};
  }
  // "Bought together" pairs, computed monthly from order history and stored in shop.metafields.ameen.cart_pairs:
  // {h:[handle,...], p:{productId:[handleIndex,...strongest first]}}
  var PAIRS = window.AMEEN_PAIRS && window.AMEEN_PAIRS.h ? window.AMEEN_PAIRS : null;
  var prodCache = {};
  function warmImg(src){ if(src){ var i=new Image(); i.decoding='async'; i.src=src; } }
  function fetchProduct(handle){
    if(!prodCache[handle]){
      prodCache[handle] = fetch('/products/'+encodeURIComponent(handle)+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          if(!p || !p.variants) return null;
          var v = p.variants.filter(function(x){ return x.available; })[0];
          if(!v) return null;
          var img = p.featured_image || '';
          if(img) img += (img.indexOf('?')>-1 ? '&' : '?') + 'width=120';
          warmImg(img);
          return {pid:p.id, vid:v.id, t:p.title, vt:v.title, u:p.url || ('/products/'+p.handle), img:img, c:v.price, pair:true};
        })
        .catch(function(){ return null; });
    }
    return prodCache[handle];
  }
  // Warm the popular add-on thumbnails once, so cards never flash an empty box when the row refreshes.
  if(ADDONS.length){ setTimeout(function(){ ADDONS.slice(0,12).forEach(function(a){ warmImg(a.img); }); }, 1500); }
  function pairedFor(cart){
    if(!PAIRS) return Promise.resolve([]);
    var inCartPid = {}, inCartHandle = {};
    (cart.items||[]).forEach(function(i){ inCartPid[i.product_id]=1; if(i.handle) inCartHandle[i.handle]=1; });
    var score = {};
    (cart.items||[]).forEach(function(i){
      (PAIRS.p[String(i.product_id)]||[]).forEach(function(idx, rank){
        var h = PAIRS.h[idx]; if(!h || inCartHandle[h]) return;
        score[h] = (score[h]||0) + 1/(rank+1);   // strongest pairing counts most; items paired with several cart lines rise
      });
    });
    var handles = Object.keys(score).sort(function(a,b){ return score[b]-score[a]; }).slice(0,6);
    return Promise.all(handles.map(fetchProduct)).then(function(list){
      return list.filter(function(a){ return a && !inCartPid[a.pid]; });
    });
  }
  var renderSeq = 0;
  function renderAddons(cart){
    if(!ensureBox()) return;
    if(!ADDONS.length && !PAIRS || !cart || !cart.item_count){ box.style.display='none'; return; }
    var seq = ++renderSeq;
    pairedFor(cart).then(function(pairs){
      if(seq !== renderSeq) return;                // a newer cart change already re-rendered
      var thr = threshold(cart.currency||'CAD'), total = Number(cart.total_price)||0;
      var gap = thr>0 && total<thr ? thr-total : 0;
      if(gap>0){                                    // within pairings, the ones that also unlock free shipping go first
        pairs = pairs.filter(function(a){ return a.c>=gap; }).concat(pairs.filter(function(a){ return a.c<gap; }));
      }
      pairs = pairs.slice(0,4);
      var seen = {}; pairs.forEach(function(a){ seen[a.pid]=1; });
      var popular = pickAddons(cart).list.filter(function(a){ return !seen[a.pid]; });
      var list = pairs.concat(popular).slice(0,6);
      if(!list.length){ box.style.display='none'; return; }
      var cur = cart.currency || 'CAD';
      var heading = pairs.length ? 'Goes well with your cart' : 'Popular add-ons';
      box.innerHTML = '<p class="ab-addons__h">'+heading+'</p><div class="ab-addons__row">' + list.map(function(a){
        var tag = gap>0 && a.c>=gap ? '<span class="ab-addon__tag">Unlocks free shipping</span>' : '';
        var vt = (a.vt && a.vt!=='Default Title') ? esc(a.vt)+' · ' : '';
        return '<form class="ab-addon" action="/cart/add" method="post">'
          + '<input type="hidden" name="id" value="'+a.vid+'"><input type="hidden" name="quantity" value="1">'
          + (a.img ? '<img src="'+esc(a.img)+'" alt="" loading="eager" decoding="async" width="40" height="40">' : '<span></span>')
          + '<div><a class="ab-addon__t" href="'+esc(a.u)+'">'+esc(a.t)+'</a><div class="ab-addon__s">'+vt+'<b>'+curFmt(a.c,cur)+'</b></div>'+tag+'</div>'
          + '<button type="submit" aria-label="Add '+esc(a.t)+' to cart">+</button></form>';
      }).join('') + '</div>';
      box.style.display='block';
    });
  }
  function refresh(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(renderAddons)
      .catch(function(){});
  }
  // Tall screens (most laptops, desktops, tablets): dock the row just above the cart footer so it is
  // always visible. Short screens (phones in landscape, small laptops): keep it at the end of the
  // scrolling item list so the cart lines keep their room.
  var DOCK_MIN_H = 760;
  function wantDock(){ return window.innerHeight >= DOCK_MIN_H; }
  var box = null;
  function ensureBox(){
    var items = document.getElementById('cartItems');
    if(!items) return null;
    if(!box){
      box = document.createElement('div'); box.className='ab-addons'; box.id='abAddons';
      // Disable the button that was tapped so a double tap can't add two.
      box.addEventListener('submit', function(e){ var b=e.target.querySelector('button'); if(b){ b.disabled=true; b.textContent='✓'; } }, true);
      // A plain mouse wheel scrolls the row sideways while it still has room to move; at either end the
      // wheel falls through to the cart list as normal. Trackpad sideways swipes are left untouched.
      box.addEventListener('wheel', function(e){
        var row = e.target.closest && e.target.closest('.ab-addons__row');
        if(!row || e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var max = row.scrollWidth - row.clientWidth; if(max <= 0) return;
        var dy = e.deltaMode === 1 ? e.deltaY*16 : e.deltaY;
        if((dy > 0 && row.scrollLeft < max - 1) || (dy < 0 && row.scrollLeft > 0)){
          row.scrollLeft += dy; e.preventDefault();
        }
      }, {passive:false});
    }
    var dock = wantDock();
    box.classList.toggle('ab-addons--dock', dock);
    if(dock){
      if(box.previousSibling!==items || box.parentNode!==items.parentNode) items.parentNode.insertBefore(box, items.nextSibling);
    } else if(box.parentNode!==items){
      // Sits at the end of the scrolling item list, so it scrolls with the cart lines instead of taking fixed space.
      items.appendChild(box);
    }
    return box;
  }
  var rzT;
  window.addEventListener('resize', function(){ clearTimeout(rzT); rzT=setTimeout(function(){ if(box && box.classList.contains('ab-addons--dock')!==wantDock()) ensureBox(); },150); });
  function mountCart(){
    var items = document.getElementById('cartItems');
    if(!items) return false;
    // ameen-cart.js rewrites #cartItems on every cart change; re-pick add-ons whenever it does,
    // but ignore the mutation caused by re-attaching our own box (otherwise it would loop).
    var t;
    new MutationObserver(function(muts){
      var external = muts.some(function(m){
        return [].some.call(m.addedNodes, function(n){ return n!==box; }) || [].some.call(m.removedNodes, function(n){ return n!==box; });
      });
      if(!external) return;
      clearTimeout(t); t=setTimeout(refresh,60);
    }).observe(items,{childList:true});
    refresh();
    return true;
  }
  if(!mountCart()){
    var tries=0, iv=setInterval(function(){ if(mountCart() || ++tries>40) clearInterval(iv); }, 150);
  }

  /* ---------- 2. Per-unit pricing on product pages ---------- */
  var opts = document.querySelectorAll('#optRow .opt');
  // A variant without its own image renders data-img as a Liquid error string; clear it so
  // clicking that size keeps the current photo instead of loading a broken image.
  opts.forEach(function(o){ if(/^\s*Liquid error/i.test(o.dataset.img||'')) o.dataset.img=''; });
  if(opts.length < 2) return;
  function parseMoney(s){
    var m = (s||'').match(/\d[\d.,\s ]*/); if(!m) return null;
    var raw = m[0].replace(/[\s ]/g,'').replace(/[.,]$/,'');
    var lastSep = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(','));
    var decimals = 0, sep = '.';
    if(lastSep > -1 && raw.length-lastSep-1 <= 2){ decimals = raw.length-lastSep-1; sep = raw.charAt(lastSep); }
    var num = decimals ? Number(raw.slice(0,lastSep).replace(/[.,]/g,'') + '.' + raw.slice(lastSep+1)) : Number(raw.replace(/[.,]/g,''));
    if(!isFinite(num)) return null;
    return {value:num, decimals:decimals, sep:sep, token:m[0].replace(/[\s ]+$/,''), str:s};
  }
  function formatLike(p, value){
    var fixed = value.toFixed(p.decimals);
    if(p.sep===',') fixed = fixed.replace('.',',');
    return p.str.replace(p.token, fixed);
  }
  function parseSize(title){
    var m = (title||'').match(/(\d+(?:\.\d+)?)\s*(kg|g|ml)\b/i);
    if(!m) return null;
    var n = Number(m[1]), u = m[2].toLowerCase();
    if(u==='kg'){ n = n*1000; u='g'; }
    return {qty:n, unit:u};
  }
  var data = [];
  opts.forEach(function(o){
    var price = parseMoney(o.dataset.price), size = parseSize(o.dataset.title);
    if(price && size && size.qty>0) data.push({el:o, price:price, size:size});
  });
  if(data.length < 2) return;
  var unit = data[0].size.unit;
  if(data.some(function(d){ return d.size.unit!==unit; })) return;
  var smallest = Math.min.apply(null, data.map(function(d){ return d.size.qty; }));
  var base = smallest < 10 ? 1 : 100;            // saffron-type items read per gram, everything else per 100 g / 100 ml
  var label = '/' + (base===1 ? '' : '100') + unit;
  data.forEach(function(d){ d.per = d.price.value / d.size.qty * base; d.perText = formatLike(d.price, d.per) + label; });
  var best = data.reduce(function(a,b){ return b.per < a.per ? b : a; });
  var worst = data.reduce(function(a,b){ return b.per > a.per ? b : a; });
  var showBest = best.per <= worst.per * 0.9;     // only call out "Best value" when the gap is real (10%+ per unit)
  data.forEach(function(d){
    var u = document.createElement('small'); u.className='ab-unit'; u.textContent = d.perText; d.el.appendChild(u);
    if(showBest && d===best){ var b=document.createElement('em'); b.className='ab-best'; b.textContent='Best value'; d.el.appendChild(b); }
  });
  var priceRow = document.querySelector('.pdp__price');
  if(priceRow){
    var line = document.createElement('span'); line.className='ab-unitline'; line.id='abUnitLine';
    priceRow.parentNode.insertBefore(line, priceRow.nextSibling);
    var sync = function(){
      var active = document.querySelector('#optRow .opt.active');
      var d = data.filter(function(x){ return x.el===active; })[0];
      line.textContent = d ? d.perText.replace('/', ' per ') : '';
      line.style.display = d ? '' : 'none';
    };
    opts.forEach(function(o){ o.addEventListener('click', function(){ setTimeout(sync,0); }); });
    sync();
  }
})();
